import Vue from 'vue'
import Router, { Route } from 'vue-router'

Vue.use(Router)

export default new Router({
  scrollBehavior(to: Route, from: Route) {
    if (to.name === from.name) { return }

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/pre',
      name: 'Pre',
      component: () => import(/* webpackChunkName: "pre" */ './views/Pre.vue'),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },
    {
      path: '/service',
      name: 'Service',
      component: () => import(/* webpackChunkName: "service" */ './views/Service.vue'),
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue'),
    },
    {
      path: '/waiting',
      name: 'Waiting',
      component: () => import(/* webpackChunkName: "waiting" */ './views/Waiting.vue'),
    },
    {
      path: '/player',
      name: 'Player',
      component: () => import(/* webpackChunkName: "player" */ './views/Player.vue'),
    },
    {
      path: '/end',
      name: 'End',
      component: () => import(/* webpackChunkName: "end" */ './views/End.vue'),
    },
    {
      path: '/grant/:grantToken',
      name: 'GrantLogin',
      beforeEnter (to, _, next) {
        localStorage.setItem('party_grant_token', to.params.grantToken)
        next('/')
      }

    },
    {
      path: '*',
      redirect: '/'
    },
  ],
})
